import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { removeEmptyQueryParams, removeOuterQueryParams } from "./pages-paths";

interface IQueryItem {
  name: string;
  val: any;
}
export const usePushQueryToRouter = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const createQueryString = useCallback(
    (queryItems: IQueryItem[], resetPage: boolean) => {
      const params = new URLSearchParams(searchParams!);
      removeOuterQueryParams(params);
      queryItems.forEach((item) => params.set(item.name, item.val));
      if (params.has("page") && resetPage) params.set("page", "1");
      removeEmptyQueryParams(params);
      return params?.toString();
    },
    [searchParams]
  );
  const pushQueryToRouter = (query: IQueryItem[], resetPage = false) => {
    router.push(pathname + "?" + createQueryString(query, resetPage));
  };
  return { pushQueryToRouter };
};
